export const BIG_COMMERCE_LIMIT_CHARS = 10000000;